// code ...import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, { parseFractionLikeInput as parseFraction, formatLatexPreview } from "../../../../components/inputs/FractionInput";

const DEC_TOL = 0.01;
const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function generateTask() {
  const A = Array.from({ length: 14 }, (_, i) => i + 3); // 3..16
  const a = pick(A), b = pick(A), c = pick(A), d = pick(A);
  const Ob = a + b + c + d;
  return { type: "TrapezoidPerimeterFromSidesTask", data: { a, b, c, d, Ob } };
}

export function renderTask({ data }) {
  const { a, b, c, d } = data;
  return (
    <div style={{ marginTop: 8, marginBottom: 8 }}>
      Dany jest trapez o bokach <InlineMath math={`a=${a}`} />, <InlineMath math={`b=${b}`} />, <InlineMath math={`c=${c}`} />, <InlineMath math={`d=${d}`} />.
      Oblicz jego obwód <InlineMath math={"Ob"} />.
    </div>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  const normalize = (v) => (typeof v === "string" ? v : v?.raw ?? "");
  return (
    <FractionInput value={raw} onChange={(v) => onChange({ raw: normalize(v) })} disabled={disabled} label="Ob" placeholder="np. 40" />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return false;
  const val = parseFraction(raw);
  return Number.isFinite(val) && Math.abs(val - data.Ob) <= DEC_TOL;
}

export const renderAnswer = ({ data }) => <InlineMath math={`Ob=${data.Ob}`} />;

export function renderExplanation({ data }) {
  const { a, b, c, d, Ob } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <strong>Krok 1.</strong> Wzór na obwód trapezu: <InlineMath math={"Ob=a+b+c+d"} />.
      <BlockMath math={`Ob=${a}+${b}+${c}+${d}=${Ob}`} />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  const raw = typeof userAnswer === "string" ? userAnswer : userAnswer?.raw ?? "";
  if (!raw) return <i>(brak odpowiedzi)</i>;
  return <InlineMath math={formatLatexPreview(raw, "Ob")} />;
}

export default { generateTask, renderTask, renderInput, checkAnswer, renderAnswer, renderExplanation, renderUserAnswer };
